import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexCenter, NumberDisplay, SpaceBetween, TextBody, TextBodySkeleton } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { MaxSlippageTooltip } from "./MaxSlippageTooltip";
import { SwapDetailsMaxSlippageItemFragment } from "./SwapDetailsMaxSlippageItem.fragment";
export function SwapDetailsMaxSlippageItem(t0) {
  const $ = _c(23);
  const {
    quote: quoteKey
  } = t0;
  const quote = readFragment(SwapDetailsMaxSlippageItemFragment, quoteKey);
  const t = useTranslations("wallet.SwapDetailsMaxSlippageItem");
  if (!quote) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsMaxSlippageItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const T0 = SpaceBetween;
  let t1;
  if ($[1] !== t) {
    t1 = t("maxSlippage");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaxSlippageTooltip><Info size={16} /></MaxSlippageTooltip>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <FlexCenter className="gap-1">{t2}{t3}</FlexCenter>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const T1 = FlexCenter;
  const t5 = "gap-1.5";
  const T2 = TextBody;
  const t6 = true;
  const T3 = NumberDisplay;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      maximumFractionDigits: 2
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = "percent";
  const t9 = bn(quote.slippageTolerance).div(100);
  let t10;
  if ($[9] !== T3 || $[10] !== t7 || $[11] !== t9) {
    t10 = <T3 custom={t7} display={t8} value={t9} />;
    $[9] = T3;
    $[10] = t7;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== T2 || $[14] !== t10) {
    t11 = <T2 asChild={t6}>{t10}</T2>;
    $[13] = T2;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== T1 || $[17] !== t11) {
    t12 = <T1 className={t5}>{t11}</T1>;
    $[16] = T1;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== T0 || $[20] !== t12 || $[21] !== t4) {
    t13 = <T0>{t4}{t12}</T0>;
    $[19] = T0;
    $[20] = t12;
    $[21] = t4;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
const SwapDetailsMaxSlippageItemSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsMaxSlippageItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("maxSlippage");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBodySkeleton className="w-[50px]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};